var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8333 6.16732H7.83333V1.16732C7.83333 0.946304 7.74553 0.734343 7.58925 0.578062C7.43297 0.421782 7.22101 0.333984 6.99999 0.333984C6.77898 0.333984 6.56702 0.421782 6.41074 0.578062C6.25446 0.734343 6.16666 0.946304 6.16666 1.16732V6.16732H1.16666C0.945648 6.16732 0.733686 6.25512 0.577406 6.4114C0.421126 6.56768 0.333328 6.77964 0.333328 7.00065C0.333328 7.22166 0.421126 7.43363 0.577406 7.58991C0.733686 7.74619 0.945648 7.83398 1.16666 7.83398H6.16666V12.834C6.16666 13.055 6.25446 13.267 6.41074 13.4232C6.56702 13.5795 6.77898 13.6673 6.99999 13.6673C7.22101 13.6673 7.43297 13.5795 7.58925 13.4232C7.74553 13.267 7.83333 13.055 7.83333 12.834V7.83398H12.8333C13.0543 7.83398 13.2663 7.74619 13.4226 7.58991C13.5789 7.43363 13.6667 7.22166 13.6667 7.00065C13.6667 6.77964 13.5789 6.56768 13.4226 6.4114C13.2663 6.25512 13.0543 6.16732 12.8333 6.16732Z",
    fill: "#1A1507"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/Plus.25a2db0db6d40ae1e4c05b07b5cffe5b.svg";
export { ForwardRef as ReactComponent };